import React, { forwardRef, useMemo } from 'react';
import Label from '@components/Label';
import { SubMenuItem } from '../SubMenuItem';

import * as styles from './style.module.scss';
import * as subMenuItemStyles from '../SubMenuItem/style.module.scss';

const {
  subMenu,
  subMenu__linkContainer,
  subMenu__ctaSection,
  subMenu__contentSection,
  subMenu__layout,
} = styles;

const { subMenuItem__label } = subMenuItemStyles;

export const SubMenu = forwardRef(
  ({ submenus, iconLink, ctas = [], className }, ref) => {
    const submenuColumnSpan = useMemo(() => {
      if (!submenus?.length) return 0;

      let submenuColumns = 0;
      submenus.forEach((submenu) => {
        submenuColumns += submenu.columns || 1;
      });

      return submenuColumns;
    }, [submenus]);

    const ctaColumnSpan = useMemo(() => {
      if (!ctas?.length) return 0;

      let ctaColumns = 0;
      ctas.forEach((cta) => {
        ctaColumns += cta.columns || 1;
      });

      return ctaColumns;
    }, [ctas]);

    return (
      <section
        className={`${subMenu} background--white ${className}`}
        ref={ref}
      >
        <section className={subMenu__layout}>
          {submenus?.length > 0 && (
            <div
              className={`${subMenu__contentSection} background--white`}
              style={{
                gridColumn: `span ${submenuColumnSpan}`,
              }}
            >
              {submenus.map((data, index) => (
                <SubMenuItem key={`submenu-${data.label || index}`} {...data} />
              ))}
              {iconLink && (
                <div className={subMenu__linkContainer}>{iconLink}</div>
              )}
            </div>
          )}

          {ctas?.length > 0 && (
            <div
              className={`${subMenu__ctaSection} background--light-blue`}
              style={{
                gridColumn: `span ${ctaColumnSpan}`,
              }}
            >
              {ctas.map((cta, index) => (
                <div
                  key={`cta-${index}`}
                  style={{
                    gridColumn: `span ${cta.columns || 1}`,
                    width: '100%',
                  }}
                >
                  {cta.label && (
                    <Label classes={subMenuItem__label}>{cta.label}</Label>
                  )}
                  {cta.content}
                </div>
              ))}
            </div>
          )}
        </section>
      </section>
    );
  }
);
